'use strict';

var App = App || {};

App.SiteNavigation = function () {
  'use strict';

  var $body = $('body'),
      $buttonToggleSiteNav = $('.js-toggle-site-nav'),
      $siteNav = $('.site-nav'),
      $navListsBox = $('.nav-lists-box'),
      $navLists = $('.nav-lists .nav-list'),
      $headerContentBox = $('.header-content-box'),
      $burgerIcon = $('.hamburger-menu .bar');

  var initialize = function initialize() {
    _bindNavigationToggle();
    _bindSearchToggleButton();
    _bindDocumentCloseClick();
    _bindContactLinkClick();
  };

  var _bindNavigationToggle = function _bindNavigationToggle() {
    $(document).on('click', '.js-toggle-site-nav', function () {
      if ($siteNav.hasClass("open")) {
        closeNavigation();
      } else {
        openNavigation();
      }
    });
  };

  /**
   * Binds actions when the contact link is clicked
   * @return {void}
   */
  var _bindContactLinkClick = function _bindContactLinkClick() {
    $(document).on('click', '.site-nav .nav-contact-link', function (e) {
      e.preventDefault();
      closeNavigation();
    });
  };

  var _bindDocumentCloseClick = function _bindDocumentCloseClick() {
    // Set a document click to close nav.
    $(document).on('click', window, function () {
      if ($siteNav.hasClass('open')) closeNavigation();
    });

    // Prevent in-nav click propagation to document
    $(document).on('click', '.site-header', function (e) {
      e.stopPropagation();
    });
  };

  var openNavigation = function openNavigation() {
    _setListWidths();

    var navListsHeight = $navListsBox.height();

    $burgerIcon.addClass('un-burgered');
    $headerContentBox.addClass('nav-open');
    $siteNav.width(0);
    $siteNav.css({ borderTopWidth: "1px" });
    // Freeze height to open with height of menu contents
    $siteNav.height(navListsHeight);
    $siteNav.velocity({ width: "100%" }, 500, "easeIn", function () {
      // Remove height to provide responsiveness
      $siteNav.height("inherit");
      $siteNav.addClass("open");
      _seqFadeToggleLists("in");
      _toggleSearchIconVisibility();
      _startMobileNavOptions();
    });
  };

  var closeNavigation = function closeNavigation() {
    var navListsHeight = $navListsBox.height();

    _endMobileNavOptions();
    $burgerIcon.removeClass('un-burgered');
    if ($body.hasClass('lock')) $body.removeClass("lock");
    // Set height to close with the current height of the menu
    $siteNav.height(navListsHeight);
    _toggleNavSearchFieldVisibility("close");
    _toggleSearchIconVisibility();
    _seqFadeToggleLists("out", function () {
      $siteNav.velocity({ width: 0 }, 500, "easeOutSine", function () {
        $siteNav.css({ borderTopWidth: 0 });
        // Set nav height to 0
        $siteNav.height(0);
        $siteNav.removeClass("open");
        $siteNav.width("100%");
        _toggleNavSearchFieldVisibility("close");
        $headerContentBox.removeClass('nav-open');
      });
    });
  };

  var _startMobileNavOptions = function _startMobileNavOptions() {
    // Set initial height.
    _mobileSetHeightForScroll();
    // Update height on window resize
    $(window).resize(_mobileSetHeightForScroll);
  };

  var _endMobileNavOptions = function _endMobileNavOptions() {
    // Kill the window resize handler for mobile nav
    $(window).off("resize", _mobileSetHeightForScroll);
  };

  // overflow: scroll does not work without a set height. This makes sure that the nav window is always set to the proper height. This allows for the nav to scroll below the title bar
  var _mobileSetHeightForScroll = function _mobileSetHeightForScroll() {
    if (Foundation.MediaQuery.is("small only")) {
      var heightVal = $(window).height() - $headerContentBox.height();
      $siteNav.height(heightVal);

      // If the screen is small and the boxy is not locked for scrolling, lock it
      if (!$body.hasClass('lock')) $body.addClass("lock");
    } else {
      $siteNav.height("inherit");
      if ($body.hasClass('lock')) $body.removeClass("lock");
    }
  };

  // Direction can be one of two options: in or out
  var _seqFadeToggleLists = function _seqFadeToggleLists(direction, callback) {
    var fadeToVal = direction == "in" ? 1 : 0,
        fadeInterval = 100,
        callbackTiming = fadeInterval * $navLists.length + fadeInterval,
        i = 0;

    $navLists.each(function (index, el) {
      setTimeout(function () {
        $(el).velocity({ opacity: fadeToVal }, 300);
      }, fadeInterval * i);
      i++;
    });

    setTimeout(function () {
      if (typeof callback == "function") callback();
    }, callbackTiming);
  };

  // Note: actual search functions are handled in a separate module for abstraction
  // This only has to do with this icon's specific visibility
  var _bindSearchToggleButton = function _bindSearchToggleButton() {
    $(document).on('click', '.js-toggle-nav-search', function (e) {
      e.preventDefault();
      _toggleNavSearchFieldVisibility();
      $('.site-header .site-search-input').focus();
    });
  };

  var _toggleSearchIconVisibility = function _toggleSearchIconVisibility() {
    var $searchIcon = $('.nav-search-icon'),
        setFade;

    if (Foundation.MediaQuery.atLeast("medium") && !$searchIcon.is(":visible")) {
      $searchIcon.velocity('fadeIn', 400, "easeInOut");
    } else {
      $searchIcon.velocity('fadeOut', 400, "easeInOut");
    }
  };

  // This can be overridden by passing a "close" value to the option parameter
  var _toggleNavSearchFieldVisibility = function _toggleNavSearchFieldVisibility(option) {
    var $searchFieldContainer = $('.nav-search-field-container'),
        $searchField = $('.nav-site-search-field');

    if ($headerContentBox.hasClass('search-open') || option === 'close') {
      $headerContentBox.removeClass('search-open');
      $searchFieldContainer.removeClass('open');
      $searchField.val('');
    } else {
      $headerContentBox.addClass('search-open');
      $searchFieldContainer.toggleClass('open');
      $searchField.focus();
    }
  };

  var _setListWidths = function _setListWidths() {
    var allWidths = [];

    // Get the width of the links themselves for an accurate measure of content.
    // Let CSS account for spacing between columns.
    $('.site-nav .nav-list li a').each(function () {
      allWidths.push($(this).width());
    });

    // Get largest width and assign it as a pixel value to all lists to create
    // equal sized columns.
    $('.site-nav .nav-list:not(:last)').width(Math.max.apply(null, allWidths) + 'px');
  };

  // Open and close are public since they may need to be triggered externally (example: search)
  return {
    initialize: initialize,
    openNavigation: openNavigation,
    closeNavigation: closeNavigation
  };
}();